/* eslint-disable react/no-array-index-key */
import React from "react";

import { MeasurementTypeDef } from "gql/generated/types";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { T } from "services/lang/LanguageService";

type DeviceRolesProps = {
  types: MeasurementTypeDef[];
  setTypes: React.Dispatch<React.SetStateAction<MeasurementTypeDef[]>>;
}

const DeviceRoles: React.FC<DeviceRolesProps> = ({ types, setTypes }) => {
  
  return (
    <div>
      <h6>{T("message.creating-device-roles")}</h6>
      {types.length > 0 &&
        types.map((type, index) => (
          <DeviceRole key={index} index={index} type={type} setTypes={setTypes} />
        ))}

      <Button
        icon="pi pi-plus"
        className="p-button-rounded p-button-success p-button-outlined p-button-sm mt-3"
        title={T("action.add-new-type")}
        onClick={() => setTypes(prev => [...prev, { id: "", title: "" }])}
      />
    </div>
  );
}

export default DeviceRoles;

type DeviceRoleProps = {
  index: number
  type: MeasurementTypeDef;
  setTypes: React.Dispatch<React.SetStateAction<MeasurementTypeDef[]>>;
}

const DeviceRole: React.FC<DeviceRoleProps> = ({ index, type, setTypes }) => {
  return (
    <div className="p-inputgroup w-30rem mt-5">
      <span className="p-float-label">
        <InputText
          value={type.id}
          onChange={e =>
            setTypes(prev => prev.map((t, i) => (i === index ? { ...t, id: e.target.value } : t)))
          }
          className="p-inputtext-sm"
          title="id"
          id="id"
          placeholder={`${T("action.write")} id...`}
        />
        <label htmlFor="id" className="text-sm">Id</label>
      </span>
      <span className="p-float-label">
        <InputText
          value={type.title}
          onChange={e =>
            setTypes(prev =>
              prev.map((t, i) => (i === index ? { ...t, title: e.target.value } : t))
            )
          }
          className="p-inputtext-sm"
          title={T("word.role-title")}
          id="title"
          placeholder={`${T("action.write-title")}...`}
        />
        <label htmlFor="title" className="text-sm">{T("word.title")}</label>
      </span>
      <Button
        type="button"
        icon="pi pi-times"
        className="p-button-danger p-inputgroup-addon"
        onClick={() => setTypes(prev => prev.toSpliced(index, 1))}
      />
    </div>
  );
}